import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    
    try {
      const res = await api.post("/auth/login", { email, password });

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      
      // Redirect based on role
      if (res.data.user.role === "admin") {
        navigate("/admin");
      } else if (res.data.user.role === "coordinator") {
        navigate("/coordinator");
      } else {
        navigate("/student");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError(
        err.response?.status === 500
          ? "Server error — check that MongoDB is connected (/api/health). If the database is new, create an admin user in Atlas."
          : err.response?.data?.error || "Login failed. Check email and password."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-green-900">
      <img
        src="/sksu-logo.png"
        alt="SKSU Logo"
        className="h-28 w-28 mb-6 object-contain drop-shadow-xl rounded-full bg-white/95 p-2 border-4 border-green-200"
        style={{ background: 'white' }}
      />
      <h2 className="text-2xl font-bold mb-4 text-white">Login</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4 w-80">
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          className="p-2 rounded text-black"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          className="p-2 rounded text-black"
          required
        />
        {error && <div className="text-red-400 text-sm">{error}</div>}
        <button 
          type="submit" 
          disabled={loading}
          className="bg-green-700 px-4 py-2 rounded text-white hover:bg-green-800 disabled:opacity-50"
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
      
      <div className="mt-4 text-sm text-gray-300">
        <p>Demo Credentials:</p>
        <p>Email: admin@sksu.edu.ph</p>
        <p>Password: admin123</p>
      </div>
    </div>
  );
} 